import React, {useEffect} from 'react';
import {Grid} from '@material-ui/core';
import SelectField from "../../../../FormikUtils/SelectField";
import SlantedField from "../../../../FormikUtils/SlantedField";
import {useFormikContext} from "formik";
import CuitGenerator from "../../../../FormikUtils/CuitGenerator";
import RegularInputField from "../../../../../RegularInputField";

export default function ClienteForm(props) {
    const {
        formField: {
            cuit,
            cantidadCapitas,
            tipoAfiliacion,
            sexo,
            dni
        }
    } = props;
    const {values, setFieldValue} = useFormikContext();

    const tipoAfiliacionOptions = [
        {value: '0', label: 'Obligatorio'},
        {value: '1', label: 'Voluntario'}
    ];

    const cantidadCapitasOptions = [
        {value: '1', label: '1'},
        {value: '2', label: '2'},
        {value: '3', label: '3'},
        {value: '4', label: '4'},
        {value: '5', label: '5'},
        {value: '6', label: '6'},
        {value: '7', label: '7'},
        {value: '8', label: '8'},
        {value: '9', label: '9'},
        {value: '10', label: '10'}
    ];

    const opcionesSexo = [
        {value: '1', label: 'Femenino'},
        {value: '2', label: 'Masculino'}
    ];

    useEffect(() => {
        console.log(values)
        console.log(CuitGenerator(values.dni, values.sexo))
        if (values.sexo !== '') {
            setFieldValue(cuit.name, CuitGenerator(values.dni, values.sexo))
        }
    }, [values.sexo]);

    return (
        <React.Fragment>
            <Grid container spacing={3}>
                <Grid item xs={12} sm={12}>
                    <SelectField
                        name={sexo.name}
                        label={sexo.label}
                        data={opcionesSexo}
                        fullWidth
                    />
                </Grid>
                <Grid item xs={12} sm={12}>
                    <SlantedField value={values.dni} label={dni.label}/>
                </Grid>
                <Grid item xs={12} sm={12}>
                    <RegularInputField
                        name={cuit.name}
                        label={cuit.label}
                        fullWidth
                    />
                </Grid>
                <Grid item xs={12} sm={12}>
                    <SelectField
                        name={tipoAfiliacion.name}
                        label={tipoAfiliacion.label}
                        data={tipoAfiliacionOptions}
                        fullWidth
                    />
                </Grid>
                <Grid item xs={12} sm={12}>
                    <SelectField
                        name={cantidadCapitas.name}
                        label={cantidadCapitas.label}
                        data={cantidadCapitasOptions}
                        fullWidth
                    />
                </Grid>
            </Grid>
        </React.Fragment>
    );
}